export enum OptimizelyMethodTypeEnum {
  ACTIVATE = 'activate',
  GET_VARIANT = 'getVariant',
}
